/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CameraSlash(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M39.37451,18.61865a8.00027,8.00027,0,0,0-11.83984,10.7627L51.7334,56H47.99951a24.0275,24.0275,0,0,0-24,24V192a24.0275,24.0275,0,0,0,24,24H197.188l19.4375,21.38135a8.00027,8.00027,0,0,0,11.83984-10.7627ZM128,168a35.97306,35.97306,0,0,1-27.86426-58.75781L148.02246,161.918A35.81152,35.81152,0,0,1,128,168Z" />
        <Path d="M207.99951,56H180.2749l-13.625-20.4375A7.99942,7.99942,0,0,0,159.99365,32h-64a7.99954,7.99954,0,0,0-6.65722,3.56348l-2.00782,3.01318a8.00079,8.00079,0,0,0,.73731,9.81787L218.07959,191.41016a8.0004,8.0004,0,0,0,13.91992-5.38135V80A24.0275,24.0275,0,0,0,207.99951,56Z" />
      </G>
    </Svg>
  );
}

export default CameraSlash;
